import React, { Component } from "react";
import { Utils as QbUtils, Query, Builder, BasicConfig } from "@react-awesome-query-builder/ui";
import "@react-awesome-query-builder/ui/css/styles.css";
import { Button, Alert } from "react-bootstrap";

import Alerts from "./alerts.component";
const InitialConfig = BasicConfig;
const queryValue = { id: QbUtils.uuid(), type: "group" };
// localStorage.clear();
//const  queryValue= JSON.parse(localStorage.getItem("query"))

const config = {
  ...InitialConfig,
  fields: {
    ticker: {
      label: "Ticker",
      type: "text",
    },
    date: {
      label: "Date",
      type: "date",
      valueSources: ["value"],
    },
    type: {
      label: "Type",
      type: "select",
      valueSources: ["value"],
      fieldSettings: {
        listValues: [
          { value: "Shooting Star", title: "Shooting Star" },
          { value: "EMA", title: "EMA" },
          { value: "HA_Daily", title: "HA_Daily" },
          { value: "HA_Weekly", title: "HA_Weekly" },
        ],
      },
    },
  },
};

export default class AlertsPage extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);

    this.state = {
      content: [],
      value: "",
      timer: {},
      loadAlerts: false,
    };
  }

  componentDidMount() {
    const savedQuery = JSON.parse(localStorage.getItem("query"));

    if (savedQuery) {
      this.setState({
        tree: QbUtils.checkTree(QbUtils.loadTree(savedQuery.tree), savedQuery.config),
        config: savedQuery.config,
      });
      this.setState({ loadAlerts: true });
    } else {
      const date = new Date();
      const today = date.toISOString().split("T")[0];

      const defaultTree = QbUtils.checkTree(
        QbUtils.loadTree({
          ...queryValue,
          properties: {
            conjunction: "OR",
          },
          children1: [
            {
              id: queryValue.id,
              type: "rule",
              properties: {
                field: "date",
                operator: "equal",
                value: [`${today}`],
                valueSrc: ["value"],
                valueType: ["date"],
              },
            },
          ],
        }),
        config
      );

      this.setState({
        tree: defaultTree,
        config: config,
      });

      this.setState({ loadAlerts: true });

      const defaultJsonTree = QbUtils.getTree(defaultTree);
      localStorage.setItem("query", JSON.stringify({ tree: defaultJsonTree, config: config }));
    }
  }

  state = {
    tree: QbUtils.checkTree(QbUtils.loadTree(queryValue), config),
    config: config,
  };

  componentDidUpdate(prevProps, prevState) {
    const jsonTree = QbUtils.getTree(this.state.tree);

    if (prevState.loadAlerts && jsonTree.children1.length !== 0) {
      this.setState({
        loadAlerts: true,
      });
    }
  }

  handleClick() {
    if (!this.state.loadAlerts) {
      this.setState({ loadAlerts: true });
    }
  }

  render = () => (
    <div>
      <Query {...config} value={this.state.tree} onChange={this.onChange} renderBuilder={this.renderBuilder} />
      {this.renderResult(this.state)}
    </div>
  );

  renderBuilder = props => (
    <div className="query-builder-container" style={{ padding: "10px" }}>
      <div className="query-builder qb-lite">
        <Builder {...props} />
      </div>
    </div>
  );

  renderResult = ({ tree: immutableTree, config }) => (
    <div className="query-builder-result">
      {/* <div>Query string: <pre>{JSON.stringify(QbUtils.queryString(immutableTree, config))}</pre></div>
      <div>MongoDb query: <pre>{JSON.stringify(QbUtils.mongodbFormat(immutableTree, config))}</pre></div>
      <div>SQL where: <pre>{JSON.stringify(QbUtils.sqlFormat(immutableTree, config))}</pre></div> */}
      {/* <div>JsonLogic: <pre>{JSON.stringify(QbUtils.jsonLogicFormat(immutableTree, config))}</pre></div> */}

      {this.state.loadAlerts ? (
        <Alerts query={JSON.stringify(QbUtils.mongodbFormat(immutableTree, config))} />
      ) : (
        <Alert>There is no data to show, Enter queries to get data</Alert>
      )}
    </div>
  );

  onChange = (immutableTree, config) => {
    // Tip: for better performance you can apply `throttle` - see `examples/demo`
    this.setState({ tree: immutableTree, config: config });
    this.setState({ loadAlerts: false });
    const jsonTree = QbUtils.getTree(immutableTree);

    localStorage.setItem("query", JSON.stringify({ tree: jsonTree, config: config }));

    // `jsonTree` can be saved to backend, and later loaded to `queryValue`
  };
}
